import axios from "axios";
import { saveResponse } from "../utils/downloadFile";

/** مبدأِ API — تنها منبعِ حقیقت. هر جا آدرسِ مطلق لازم است (دانلود، window.open) از همین بگیر. */
export function apiOrigin() {
  if (typeof window === "undefined" || !window.location?.hostname) return "http://localhost:8000";
  const { protocol, hostname, host, port } = window.location;
  // توسعه (localhost) یا dev-serverِ مستقیم روی :3000 → بک‌اند روی :8000
  if (hostname === "localhost" || hostname === "127.0.0.1" || port === "3000") {
    return `${protocol}//${hostname}:8000`;
  }
  // پشتِ nginx (پورت ۸۰/۴۴۳) → هم‌مبدأ؛ nginx مسیرِ /api/ را به بک‌اند می‌دهد
  return `${protocol}//${host}`;
}

const api = axios.create({
  /* آدرسِ API:
     • اگر REACT_APP_API_URL ست شده باشد، همان.
     • روی localhost (توسعه) → بک‌اندِ :8000.
     • در غیر این صورت **هم‌مبدأ** (`/api/…` از همان host و port که صفحه آمده) — nginxِ
       سرور آن را به بک‌اند پروکسی می‌کند. قبلاً همیشه `host:8000` بود، یعنی پورتِ
       بک‌اند باید مستقیم روی اینترنت باز می‌ماند. */
  baseURL: process.env.REACT_APP_API_URL || apiOrigin(),
  headers: { "Content-Type": "application/json" },
});

// توکنِ ورود (در صورت وجود) روی هر درخواست ست می‌شود
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // 🐞 آپلودِ فایل با **۴۲۲** رد می‌شد. این نمونهٔ axios به‌صورتِ سراسری
  // `Content-Type: application/json` دارد و آپلودهایی که هدرِ خودشان را صریح
  // نمی‌دادند همان را به ارث می‌بردند؛ آن‌وقت بدنه به‌عنوانِ multipart پارس
  // نمی‌شد و FastAPI می‌گفت فیلدِ `file` نیست.
  // (به‌همین دلیل `uploadBackup` که صریحاً multipart می‌گذاشت کار می‌کرد ولی
  //  آپلودِ بیمه نه.) این‌جا برای **هر** FormData یک‌جا درست می‌شود؛ مرورگر
  //  خودش `boundary` را اضافه می‌کند.
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    config.headers = config.headers || {};
    if (typeof config.headers.set === "function") {
      config.headers.set("Content-Type", "multipart/form-data");
    } else {
      config.headers["Content-Type"] = "multipart/form-data";
    }
  }
  return config;
});

// اگر توکن منقضی/نامعتبر بود (۴۰۱)، به‌جای نمایشِ خطا، توکن را پاک و به صفحهٔ ورود برگرد
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    const hadToken = !!localStorage.getItem("sc_token");
    const isLogin = url.includes("/auth/login");
    /* ۵۰۳ِ بروزرسانی: ثبتِ کاربر رد شده ولی **دادهٔ فرمِ او دست‌نخورده است**.
       فقط به ناظرِ بروزرسانی خبر می‌دهیم تا فوراً پاپ‌آپ را نشان دهد و کاربر
       بداند چرا ذخیره نشد. صفحه هیچ‌چیزی را پاک نمی‌کند. */
    if (err?.response?.status === 503) {
      try {
        window.dispatchEvent(new CustomEvent("gx-maintenance"));
      } catch { /* noop */ }
    }
    if (err?.response?.status === 401 && hadToken && !isLogin) {
      localStorage.removeItem("sc_token");
      localStorage.removeItem("sc_user");
      // یک‌بار ریلود تا وضعیتِ ورود ریست شود و صفحهٔ ورود نشان داده شود
      if (!window.__sc_reloading) { window.__sc_reloading = true; window.location.reload(); }
    }
    return Promise.reject(err);
  }
);

/** دانلودِ هر فایلی با نامی که سرور تعیین کرده (نامِ جایگزین فقط اگر هدر نبود). */
export const downloadFile = async (url, fallback, config = {}) => {
  const r = await api.get(url, { ...config, responseType: "blob" });
  return saveResponse(r, fallback);
};

/** فایلِ اکسلِ پرداخت (مساعده و حقوق) — POST چون فهرستِ نفرات را می‌فرستیم */
/** اکسلِ مرتب از هر جدول — همان ستون‌ها و ردیف‌هایی که روی صفحه دیده می‌شوند */
export const downloadTableXlsx = async (payload, fallback = "خروجی.xlsx") => {
  const r = await api.post("/api/v1/export/table.xlsx", payload, { responseType: "blob" });
  return saveResponse(r, fallback);
};

/** فایلِ پرداختِ حقوقِ دوره (v2.125.0) — سرور وضعیتِ پرداختِ هر نفر را حساب می‌کند؛ `simple` = فقط نام + مبلغ + ستونِ خالی */
export const downloadPeriodPaymentFile = async (periodId, data, fallback = "حقوق.xlsx") => {
  const r = await api.post(`/api/v1/finance/periods/${periodId}/payment-file.xlsx`, data,
    { responseType: "blob" });
  return saveResponse(r, fallback);
};

export const downloadPaymentFile = async (data, fallback = "لیست-پرداخت.xlsx") => {
  const r = await api.post("/api/v1/finance/payment-file.xlsx", data,
    { responseType: "blob" });
  return saveResponse(r, fallback);
};

// ---- Employees ----
export const getEmployees = (params) => api.get("/api/v1/employees/", { params });
export const getEmployee = (id) => api.get(`/api/v1/employees/${id}`);
/** بازه‌های نقش/نرخ — تغییرِ سمت وسطِ ماه و «وسط‌کاری» */
export const getRolePeriods = (id) => api.get(`/api/v1/employees/${id}/role-periods`);
export const createRolePeriod = (id, data) =>
  api.post(`/api/v1/employees/${id}/role-periods`, data);
export const deleteRolePeriod = (id, rpId) =>
  api.delete(`/api/v1/employees/${id}/role-periods/${rpId}`);
// نقش‌ها و بازه‌های یک ماه — «کدام روز با چه مدلی» (v2.108.0)
export const getEmployeePayPlan = (id, year, month) =>
  api.get(`/api/v1/employees/${id}/pay-plan`, { params: { year, month } });
export const previewRolePeriods = (id, year, month) =>
  api.get(`/api/v1/employees/${id}/role-periods/preview`, { params: { year, month } });
export const createEmployee = (data) => api.post("/api/v1/employees/", data);
// `card_from`: اگر کد/کارت عوض شد، ترددها از این تاریخ جابه‌جا شوند (v2.111.0)
export const updateEmployee = (id, data, cardFrom) =>
  api.patch(`/api/v1/employees/${id}`, data, { params: cardFrom ? { card_from: cardFrom } : {} });
/** حذف پرسنل — پیش‌فرض غیرفعال‌سازی؛ `{hard:true}` حذفِ کامل (فقط بدونِ سابقه) */
export const deleteEmployee = (id, { hard = false } = {}) =>
  api.delete(`/api/v1/employees/${id}`, { params: hard ? { hard: true } : {} });
// v2.152.12 ترک کار (دسته‌جمعی) — `termination_date: null` ⇒ برگشت به کار
export const terminateEmployees = (data) => api.post("/api/v1/employees/terminate", data);
export const getDepartments = () => api.get("/api/v1/departments/");
// عکسِ ۳×۴ و فرمِ ثبت‌نامِ پرسنل (v2.99.0)
export const uploadEmployeePhoto = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/api/v1/employees/${id}/photo`, fd);
};
/** عکس با هدرِ احراز هویت می‌آید، پس به‌شکلِ blob گرفته و به objectURL تبدیل می‌شود */
export const fetchEmployeePhoto = (id) =>
  api.get(`/api/v1/employees/${id}/photo`, { responseType: "blob" });
export const deleteEmployeePhoto = (id) => api.delete(`/api/v1/employees/${id}/photo`);
export const downloadRegistrationForm = (id, fallback) =>
  downloadFile(`/api/v1/employees/${id}/registration-form.pdf`, fallback || `registration_${id}.pdf`);
export const downloadBlankRegistrationForm = () =>
  downloadFile("/api/v1/employees/registration-form/blank.pdf", "registration_form_blank.pdf");

/** ایمپورت پرسنل از لیستِ کارخانه — لیست پرسنل اجباری، پایه حقوق ثابت اختیاری */
const _employeeImportForm = (personnelFile, salaryFile, path, overrides) => {
  const fd = new FormData();
  fd.append("personnel_file", personnelFile);
  if (salaryFile) fd.append("salary_file", salaryFile);
  // اصلاحاتِ دستیِ جدولِ پیش‌نمایش؛ خودِ فایل دست‌نخورده می‌ماند
  if (overrides && overrides.length) fd.append("overrides", JSON.stringify(overrides));
  return api.post(`/api/v1/employees/${path}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
/** پیش‌نمایش — هیچ چیزی ذخیره نمی‌شود */
export const previewEmployeesImport = (personnelFile, salaryFile, overrides) =>
  _employeeImportForm(personnelFile, salaryFile, "import/preview", overrides);
/** اعمالِ تراکنشی */
export const applyEmployeesImport = (personnelFile, salaryFile, overrides) =>
  _employeeImportForm(personnelFile, salaryFile, "import/apply", overrides);

// ---- Attendance ----
export const getAttendance = (year, month, employee_id) =>
  api.get("/api/v1/attendance/", { params: { year, month, employee_id } });
export const updateAttendance = (id, data) => api.patch(`/api/v1/attendance/${id}`, data);
export const deleteAttendance = (id) => api.delete(`/api/v1/attendance/${id}`);
/** ثبتِ دستیِ حضورِ ماه — یک ردیف per نفر (حضور/غیبت/کسرکار/اضافه‌کاری) */
export const getManualMonthAttendance = (year, month) =>
  api.get("/api/v1/attendance/manual-month", { params: { year, month } });
export const saveManualMonthAttendance = (year, month, rows) =>
  api.post("/api/v1/attendance/manual-month/bulk", { year, month, rows });

/**
 * ایمپورتِ فایلِ دستگاه — همیشه **محدود به یک ماه**.
 *
 * فایلِ دستگاه معمولاً چند ماه را با هم دارد؛ بدونِ year/month ایمپورتِ «مرداد»
 * ترددِ تیر را هم دوباره می‌نویسد و اعداد تجمیع می‌شوند.
 */
const _attForm = (file, path, year, month) => {
  const form = new FormData();
  form.append("file", file);
  return api.post(`/api/v1/attendance/${path}`, form, { params: { year, month } });
};
export const importAttendanceFile = (file, year, month) =>
  _attForm(file, "import", year, month);
/** پیش‌نمایشِ ایمپورت حضور — هیچ چیزی ذخیره نمی‌شود */
export const previewAttendanceFile = (file, year, month) =>
  _attForm(file, "import/preview", year, month);

/** چه چیزی از این ماه در سیستم هست (برای دکمهٔ حذفِ ماه) */
export const getAttendanceMonthData = (year, month) =>
  api.get("/api/v1/attendance/month-data", { params: { year, month } });
/** پاک‌کردنِ دادهٔ حضورِ یک ماه تا ایمپورتِ دوباره تجمیع نشود */
export const deleteAttendanceMonthData = (year, month, keep_manual = true, admin_pin) =>
  api.delete("/api/v1/attendance/month-data",
    { params: { year, month, keep_manual, admin_pin } });
/** پرسنلی که باید در حضوروغیاب باشند ولی این ماه ترددی ندارند */
export const getAttendanceMissingEmployees = (year, month) =>
  api.get("/api/v1/attendance/missing-employees", { params: { year, month } });

export const getRawPunches = (params) =>
  api.get("/api/v1/attendance/raw-punches", { params });
export const getUnmappedDevices = (params) =>
  api.get("/api/v1/attendance/unmapped-devices", { params });
export const mapDevice = (device_uid, employee_id, employee_code) =>
  api.post("/api/v1/attendance/map-device", { device_uid, employee_id, employee_code });
export const setDeviceLabel = (device_uid, label, note) =>
  api.post("/api/v1/attendance/device-label", { device_uid, label, note });
/** نگاشتِ کدهای کارتِ دستگاه (۴رقمی) و کدِ پرسنلی (۵رقمی) از خروجیِ نام‌دارِ دستگاه */
const _rosterForm = (file, path, overrides, createCodes) => {
  const fd = new FormData();
  fd.append("file", file);
  const params = {};
  if (overrides && Object.keys(overrides).length) params.overrides = JSON.stringify(overrides);
  if (createCodes && createCodes.length) params.create_codes = JSON.stringify(createCodes);
  return api.post(`/api/v1/attendance/device-roster/${path}`, fd, {
    params, headers: { "Content-Type": "multipart/form-data" },
  });
};
export const previewDeviceRoster = (file, overrides, createCodes) =>
  _rosterForm(file, "preview", overrides, createCodes);
export const applyDeviceRoster = (file, overrides, createCodes) =>
  _rosterForm(file, "apply", overrides, createCodes);
// Phase 2 — کاردکس و بازبینی ماهانه
export const getCardex = (employeeId, year, month) =>
  api.get(`/api/v1/attendance/cardex/${employeeId}`, { params: { year, month } });
export const getAttendanceReview = (params) =>
  api.get("/api/v1/attendance/review", { params });
export const getAttendancePeriodReport = (params) =>
  api.get("/api/v1/attendance/period-report", { params });
/** تأییدِ یک‌جای همهٔ روزهای رسیدگی‌نشدهٔ یک نفر در یک ماه (یک تراکنش، نه ۳۱ درخواست) */
export const bulkApproveAttendance = (data, admin_pin) =>
  api.post("/api/v1/attendance/review/bulk-approve", data,
    { params: admin_pin ? { admin_pin } : {} });
export const getAttendanceMonthlySummary = (params) =>
  api.get("/api/v1/attendance/monthly-summary", { params });
/** اصلاح‌های همگانیِ ساعتِ کاری (per روز) */
export const getDayRules = (year, month) =>
  api.get("/api/v1/attendance/day-rules", { params: { year, month } });
export const upsertDayRule = (data) => api.post("/api/v1/attendance/day-rules", data);
export const deleteDayRule = (id) => api.delete(`/api/v1/attendance/day-rules/${id}`);

/** گریدِ هفتگی — ردیف=پرسنل، ستون=روزهای هفته */
export const getAttendanceWeeklyGrid = (year, month, week, employee_id) =>
  api.get("/api/v1/attendance/weekly-grid",
    { params: { year, month, week, employee_id } });
export const getAttendanceMonthlyStatus = (year, month) =>
  api.get("/api/v1/attendance/monthly-status", { params: { year, month } });
export const finalizeAttendanceMonth = (data, admin_pin) =>
  api.post("/api/v1/attendance/monthly-finalize", data, { params: admin_pin ? { admin_pin } : {} });
export const manualCorrectDay = (data, admin_pin) =>
  api.patch("/api/v1/attendance/manual-day", data, { params: admin_pin ? { admin_pin } : {} });
/** درخواستِ اصلاحِ حضورِ ماهِ نهایی‌شده برای مدیر، و تأیید/ردِ آن (v2.124.0) */
export const createAttendanceChangeRequest = (data) => api.post("/api/v1/attendance/change-requests", data);
export const decideAttendanceChangeRequest = (noteId, approve) =>
  api.post(`/api/v1/attendance/change-requests/${noteId}/decide`, null, { params: { approve } });
export const setAttendanceReview = (data, admin_pin) =>
  api.patch("/api/v1/attendance/review", data, { params: admin_pin ? { admin_pin } : {} });
// Phase 3 — دفتر مالی
export const getFinanceTxns = (params) => api.get("/api/v1/finance/transactions", { params });
/** دفترِ اسنادِ مالی — تراکنش‌ها + اصلِ بدهی‌ها، با ماندهٔ تا هر سند */
/** تنخواه — صندوقِ شارژشونده */
export const getPettyAccounts = (params) => api.get("/api/v1/petty-cash/accounts", { params });
export const createPettyAccount = (data) => api.post("/api/v1/petty-cash/accounts", data);
export const updatePettyAccount = (id, data) => api.patch(`/api/v1/petty-cash/accounts/${id}`, data);
export const getPettyEntries = (params) => api.get("/api/v1/petty-cash/entries", { params });
export const addPettyEntry = (data) => api.post("/api/v1/petty-cash/entries", data);
export const deletePettyEntry = (id) => api.delete(`/api/v1/petty-cash/entries/${id}`);
export const updatePettyEntry = (id, data) => api.patch(`/api/v1/petty-cash/entries/${id}`, data);
// v2.160.0 — حساب‌های بانکیِ چندگانه + بررسیِ شبا
export const getBankAccounts = (id) => api.get(`/api/v1/employees/${id}/bank-accounts`);
export const addBankAccount = (id, data) => api.post(`/api/v1/employees/${id}/bank-accounts`, data);
export const updateBankAccount = (id, accId, data) => api.patch(`/api/v1/employees/${id}/bank-accounts/${accId}`, data);
export const deleteBankAccount = (id, accId) => api.delete(`/api/v1/employees/${id}/bank-accounts/${accId}`);
export const makePrimaryBankAccount = (id, accId) =>
  api.post(`/api/v1/employees/${id}/bank-accounts/${accId}/make-primary`);
export const checkIban = (iban, bank_name) => api.get("/api/v1/employees/iban-check", { params: { iban, bank_name } });
export const postPettyEntryToPerson = (id, data) =>
  api.post(`/api/v1/petty-cash/entries/${id}/post-to-person`, data);
/** تطبیقِ موجودی: موجودیِ واقعی داده می‌شود، مغایرت سندِ تطبیق می‌شود (۰ = صفر کردن) */
export const reconcilePettyAccount = (id, data) =>
  api.post(`/api/v1/petty-cash/accounts/${id}/reconcile`, data);

export const getFinanceDocuments = (params) =>
  api.get("/api/v1/finance/documents", { params });
export const createFinanceTxn = (data, admin_pin) =>
  api.post("/api/v1/finance/transactions", data, { params: admin_pin ? { admin_pin } : {} });
export const deleteFinanceTxn = (id) => api.delete(`/api/v1/finance/transactions/${id}`);
/** «پرداخت شد / نشد» — تا پرداخت نخورَد، سند در حسابِ شخص نمی‌نشیند */
export const setTxnPaymentStatus = (data) =>
  api.post("/api/v1/finance/transactions/payment-status", data);
export const updateFinanceTxn = (id, data) => api.patch(`/api/v1/finance/transactions/${id}`, data);
export const getEmployeeLedger = (id, params) =>
  api.get(`/api/v1/finance/employee/${id}/ledger`, { params });
export const getFinanceSummary = (employee_id, period_id) =>
  api.get("/api/v1/finance/summary", { params: { employee_id, period_id } });
export const getDebts = (params) => api.get("/api/v1/finance/debts", { params });
export const createDebt = (data) => api.post("/api/v1/finance/debts", data);
export const repayDebt = (id, data) => api.post(`/api/v1/finance/debts/${id}/repay`, data);
export const carryForwardDebt = (id, data) => api.post(`/api/v1/finance/debts/${id}/carry-forward`, data);
/** ثبتِ دسته‌جمعیِ مساعده — یا همه یا هیچ‌کدام */
export const createAdvanceBatch = (data) => api.post("/api/v1/finance/advances/batch", data);
// ویرایشِ کلِ یک دستهٔ مساعده — کم/زیاد کردنِ نفرات و مبلغ‌ها، یک‌جا و تراکنشی
export const updateAdvanceBatch = (data) => api.put("/api/v1/finance/advances/batch", data);
/** صورتحسابِ ماندهٔ لحظه‌ای (PDF) — مستقل از دورهٔ حقوق */
export const downloadStatement = (employeeId, params = {}) =>
  downloadFile(`/api/v1/finance/employee/${employeeId}/statement.pdf`,
    `statement_${employeeId}.pdf`, { params });
// Phase 4 — بیمه و راننده
/** preview=true چیزی ذخیره نمی‌کند؛ replace=true ردیف‌های قبلیِ دوره را جایگزین می‌کند. */
export const importInsurance = (
  periodId, file, { preview = true, replace = false, stage = "premium", overrides = null } = {},
) => {
  const fd = new FormData(); fd.append("file", file);
  // v2.163.0: تطبیقِ دستیِ همان صفحهٔ پیش‌نمایش {شمارهٔ سطر: employee_id}
  if (overrides && Object.keys(overrides).length) fd.append("overrides", JSON.stringify(overrides));
  // stage=premium حق بیمه (مرحلهٔ ۱) | stage=payment پرداختیِ بیمه (مرحلهٔ ۲)
  return api.post(
    `/api/v1/insurance/import?period_id=${periodId}&preview=${preview}`
    + `&replace=${replace}&stage=${stage}`, fd);
};
export const getInsuranceRecords = (params) => api.get("/api/v1/insurance/records", { params });
export const getInsuranceSummary = (period_id) => api.get("/api/v1/insurance/summary", { params: { period_id } });
export const matchInsurance = (id, employee_id) => api.patch(`/api/v1/insurance/records/${id}/match`, { employee_id });
export const createInsuranceRecord = (period_id, data) =>
  api.post(`/api/v1/insurance/records?period_id=${period_id}`, data);
export const updateInsuranceRecord = (id, data) => api.patch(`/api/v1/insurance/records/${id}`, data);
export const deleteInsuranceRecord = (id) => api.delete(`/api/v1/insurance/records/${id}`);
export const bulkUpdateInsurance = (items) => api.post("/api/v1/insurance/records/bulk-update", items);
export const getInsurancePayrollView = (period_id) =>
  api.get("/api/v1/insurance/payroll-view", { params: { period_id } });
export const exportInsurance = (period_id) =>
  api.get("/api/v1/insurance/export", { params: { period_id }, responseType: "blob" });
export const getDriverRates = () => api.get("/api/v1/drivers/tasks");
export const createDriverRate = (data) => api.post("/api/v1/drivers/tasks", data);
export const updateDriverRate = (id, data) => api.patch(`/api/v1/drivers/tasks/${id}`, data);
export const toggleDriverRate = (id) => api.post(`/api/v1/drivers/tasks/${id}/toggle`);
export const deleteDriverRate = (id) => api.delete(`/api/v1/drivers/tasks/${id}`);
export const getDriverEntries = (params) => api.get("/api/v1/drivers/entries", { params });
export const createDriverEntry = (data) => api.post("/api/v1/drivers/entries", data);
export const deleteDriverEntry = (id) => api.delete(`/api/v1/drivers/entries/${id}`);
export const getDriverSummary = (period_id) => api.get("/api/v1/drivers/summary", { params: { period_id } });
// Phase 6/7/8 — گزارش‌ها، دسترسی، ویزارد بستن حقوق
export const getReportDebtors = (period_id) => api.get("/api/v1/reports/debtors", { params: { period_id } });
export const getReportSalaryPayments = (period_id) => api.get("/api/v1/reports/salary-payments", { params: { period_id } });
export const getReportProductionOutput = () => api.get("/api/v1/reports/production-output");
export const getReportPayslip = (employee_id, period_id) => api.get(`/api/v1/reports/payslip/${employee_id}`, { params: { period_id } });
// دسترسی‌های مؤثرِ کاربرِ جاری (نقش از توکن خوانده می‌شود، نه از پارامتر)
export const getMyPermissions = () => api.get("/api/v1/meta/permissions");
export const getWizardState = (period_id) => api.get(`/api/v1/payroll/periods/${period_id}/wizard-state`);
export const approveAccountant = (period_id) => api.post(`/api/v1/payroll/periods/${period_id}/approve-accountant`);
export const approveManagement = (period_id) => api.post(`/api/v1/payroll/periods/${period_id}/approve-management`);
export const lockPeriod = (period_id, force, admin_pin) =>
  api.post(`/api/v1/payroll/periods/${period_id}/lock`, null, { params: { force, ...(admin_pin ? { admin_pin } : {}) } });
/** v2.167.0 — بستن/بازگشاییِ جداگانهٔ حقوقِ غیرکارمزدی (fixed) و کارمزدی (piece) */
export const closePayGroup = (period_id, group) =>
  api.post(`/api/v1/payroll/periods/${period_id}/close-group`, null, { params: { group } });
export const reopenPayGroup = (period_id, group, admin_pin) =>
  api.post(`/api/v1/payroll/periods/${period_id}/reopen-group`, null, { params: { group, admin_pin } });
/** بازگشاییِ کاملِ ماهِ بسته/تأییدشده با کد مدیریتی (v2.122.0) */
export const reopenPeriod = (period_id, admin_pin) =>
  api.post(`/api/v1/payroll/periods/${period_id}/reopen`, null, { params: { admin_pin } });
/** بازگشاییِ حضورِ ماهِ نهایی‌شده با کد مدیریتی */
export const reopenAttendanceMonth = (year, month, admin_pin) =>
  api.post("/api/v1/attendance/monthly-reopen", null, { params: { year, month, admin_pin } });
export const closingRevert = (period_id, admin_pin) =>
  api.post(`/api/v1/payroll/periods/${period_id}/closing-revert`, null, { params: admin_pin ? { admin_pin } : {} });
export const reprocessShortage = (params) =>
  api.post("/api/v1/attendance/reprocess-shortage", null, { params });
// admin_pin هنگام تاییدِ دوره لازم می‌شود
export const updateAttendancePin = (id, data, admin_pin) =>
  api.patch(`/api/v1/attendance/${id}`, data, { params: admin_pin ? { admin_pin } : {} });
export const deleteAttendancePin = (id, admin_pin) =>
  api.delete(`/api/v1/attendance/${id}`, { params: admin_pin ? { admin_pin } : {} });

// ---- Settings / Work schedule ----
export const getWorkSchedule = () => api.get("/api/v1/settings/work-schedule");
export const updateWorkDay = (weekday, data) =>
  api.patch(`/api/v1/settings/work-schedule/${weekday}`, data);
export const getPayrollSettings = () => api.get("/api/v1/settings/payroll-settings");
export const updatePayrollSettings = (data) =>
  api.patch("/api/v1/settings/payroll-settings", data);
// Phase 1 — تنظیمات حسابداری (قوانین تأییدشده)
export const getAccountingSettings = () => api.get("/api/v1/settings/payroll");
export const updateAccountingSettings = (data) =>
  api.patch("/api/v1/settings/payroll", data);

// ---- Users ----
export const getUsers = () => api.get("/api/v1/users/");
export const getRoles = () => api.get("/api/v1/users/roles");
export const getPermissionCatalog = () => api.get("/api/v1/users/permissions/catalog");
export const getDashboardOverview = () => api.get("/api/v1/dashboard/overview");
// یادداشت‌ها / اعلان‌ها / دفترچه
export const getNotes = (params) => api.get("/api/v1/notes/", { params });
export const getNote = (id) => api.get(`/api/v1/notes/${id}`);
export const createNote = (data) => api.post("/api/v1/notes/", data);
export const patchNote = (id, data) => api.patch(`/api/v1/notes/${id}`, data);
export const deleteNote = (id) => api.delete(`/api/v1/notes/${id}`);
export const addNoteComment = (id, body) => api.post(`/api/v1/notes/${id}/comments`, { body });
export const getMyNotebook = () => api.get("/api/v1/notes/notebook/mine");
export const addPersonalNote = (data) => api.post("/api/v1/notes/notebook", data);
export const deletePersonalNote = (id) => api.delete(`/api/v1/notes/notebook/${id}`);
export const getMentionableUsers = () => api.get("/api/v1/notes/mentionable-users");
// چت
export const getConversations = () => api.get("/api/v1/chat/conversations");
export const createConversation = (data) => api.post("/api/v1/chat/conversations", data);
export const getChatMessages = (cid) => api.get(`/api/v1/chat/conversations/${cid}/messages`);
export const sendChatMessage = (cid, body) => api.post(`/api/v1/chat/conversations/${cid}/messages`, { body });
export const chatProductionRequest = (cid, data) => api.post(`/api/v1/chat/conversations/${cid}/production-request`, data);
export const approveActionRequest = (aid) => api.post(`/api/v1/chat/action-requests/${aid}/approve`);
export const rejectActionRequest = (aid) => api.post(`/api/v1/chat/action-requests/${aid}/reject`);
// پشتیبان‌گیری
export const getBackupConfig = () => api.get("/api/v1/backup/config");
export const saveBackupConfig = (data) => api.put("/api/v1/backup/config", data);
export const runBackupNow = () => api.post("/api/v1/backup/database/run");
export const runDbBackup = () => api.post("/api/v1/backup/database/run");
export const runFilesBackup = () => api.post("/api/v1/backup/files/run");
export const listBackups = (kind) => api.get("/api/v1/backup/list", { params: kind ? { kind } : {} });
export const verifyBackup = (id) => api.get(`/api/v1/backup/${id}/verify`);
export const previewBackup = (id) => api.get(`/api/v1/backup/${id}/preview`);
export const reindexBackups = () => api.post("/api/v1/backup/reindex");
export const deleteBackup = (id) => api.delete(`/api/v1/backup/${id}`);
export const downloadBackup = async (id, filename) => {
  const r = await api.get(`/api/v1/backup/download/${id}`, { responseType: "blob" });
  return saveResponse(r, filename || `backup_${id}.dump`);
};
export const uploadBackup = (file, kind = "database") => {
  const form = new FormData(); form.append("file", file);
  return api.post("/api/v1/backup/upload", form, {
    params: { kind }, headers: { "Content-Type": "multipart/form-data" },
  });
};

// ─────────── بازیابی (روترِ جدا؛ همیشه با پینِ مدیر + متنِ تأیید) ───────────
const _fd = (obj) => {
  const f = new FormData();
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    f.append(k, Array.isArray(v) ? v.join(",") : v);
  });
  return f;
};
const _mp = { headers: { "Content-Type": "multipart/form-data" } };
export const restorePreflight = (id) => api.get(`/api/v1/restore/preflight/${id}`);
export const restoreDatabase = (data) => api.post("/api/v1/restore/database", _fd(data), _mp);
export const restoreFiles = (data) => api.post("/api/v1/restore/files", _fd(data), _mp);
export const restoreFull = (data) => api.post("/api/v1/restore/full", _fd(data), _mp);
export const restoreBackup = ({ backup_id, mode, modules, admin_pin, confirm_text }) => {
  const form = new FormData();
  form.append("backup_id", backup_id); form.append("mode", mode);
  form.append("modules", (modules || []).join(",")); form.append("admin_pin", admin_pin);
  form.append("confirm_text", confirm_text);
  return api.post("/api/v1/restore/database", form, { headers: { "Content-Type": "multipart/form-data" } });
};
export const getNotifications = () => api.get("/api/v1/notes/notifications/mine");
export const readNotification = (id) => api.post(`/api/v1/notes/notifications/${id}/read`);
export const readAllNotifications = () => api.post("/api/v1/notes/notifications/read-all");
export const createUser = (data) => api.post("/api/v1/users/", data);
export const updateUser = (id, data) => api.patch(`/api/v1/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/api/v1/users/${id}`);
export const changeMyPassword = (data) => api.post("/api/v1/auth/change-password", data);

// ---- Audit / Activity log ----
export const getAuditLogs = (params) => api.get("/api/v1/audit/", { params });
export const getAuditOptions = () => api.get("/api/v1/audit/options");

// ---- Holidays ----
export const getHolidays = (params) => api.get("/api/v1/holidays/", { params });
export const createHoliday = (data) => api.post("/api/v1/holidays/", data);
export const deleteHoliday = (id) => api.delete(`/api/v1/holidays/${id}`);

// ---- Leaves ----
export const getLeaves = (params) => api.get("/api/v1/leaves/", { params });
export const createLeave = (data) => api.post("/api/v1/leaves/", data);
export const deleteLeave = (id) => api.delete(`/api/v1/leaves/${id}`);
export const getAdjacentHolidays = (leave_date) =>
  api.get("/api/v1/leaves/adjacent-holidays", { params: { leave_date } });

// ---- Payroll record edit/delete (admin_pin when approved) ----
export const updatePayrollRecord = (periodId, recordId, data, admin_pin) =>
  api.patch(`/api/v1/payroll/periods/${periodId}/records/${recordId}`, data,
    { params: admin_pin ? { admin_pin } : {} });
export const deletePayrollRecord = (periodId, recordId, admin_pin) =>
  api.delete(`/api/v1/payroll/periods/${periodId}/records/${recordId}`,
    { params: admin_pin ? { admin_pin } : {} });

// ---- Payroll ----
export const getPeriods = () => api.get("/api/v1/payroll/periods");
export const createPeriod = (data) => api.post("/api/v1/payroll/periods", data);
/** «چرا حقوقِ این نفر این‌قدر شد؟» — تفکیکِ پایه/غیبت/کسورات/خالص */
export const explainPayroll = (periodId, employeeId) =>
  api.get(`/api/v1/payroll/periods/${periodId}/explain/${employeeId}`);

// ---- مانده و پرداختِ حقوق (سرویسِ واحدِ مالی) ----
export const getBalances = (params) => api.get("/api/v1/finance/balances", { params });
// v2.173.0 — هشدارهای پیش از ثبت (مبلغِ غیرعادی/تکراری/اسمِ همکار/بیش از طلب) و «سلامت حساب‌ها»
export const checkFinanceEntry = (data) => api.post("/api/v1/finance/check-entry", data);
export const getLedgerHealth = () => api.get("/api/v1/finance/ledger-health");
// v2.133.0 — انتقال بین پرسنل (چکِ یک نفر برای حقوقِ چند نفر / حقوقِ یکی برای بدهیِ خانواده‌اش)
// v2.144.0 — قلمِ حقوقی از اسنادِ مالی ⇒ ردیفِ اصلاحیِ «محاسبه و بستن حقوق» + محاسبهٔ خودکار
export const createPayrollItem = (data) => api.post("/api/v1/finance/payroll-items", data);
export const getTransfers = () => api.get("/api/v1/finance/transfers");
export const createTransfer = (data) => api.post("/api/v1/finance/transfers", data);
export const updateTransfer = (inTxnId, data) => api.put(`/api/v1/finance/transfers/${inTxnId}`, data);
export const deleteTransfer = (inTxnId) => api.delete(`/api/v1/finance/transfers/${inTxnId}`);
export const getPeriodSalaryPayments = (periodId) =>
  api.get(`/api/v1/finance/periods/${periodId}/salary-payments`);
export const recordSalaryPayment = (periodId, data) =>
  api.post(`/api/v1/finance/periods/${periodId}/salary-payments`, data);
export const payPeriodSalariesBulk = (periodId, data) =>
  api.post(`/api/v1/finance/periods/${periodId}/salary-payments/bulk`, data);
export const deleteSalaryPayment = (id) =>
  api.delete(`/api/v1/finance/salary-payments/${id}`);
// v2.137.0 — ویرایشِ پرداختِ هر نفر + بستن/بازگشاییِ پروندهٔ پرداختِ ماه
export const getSalaryPaymentItems = (periodId, employeeId) =>
  api.get(`/api/v1/finance/periods/${periodId}/salary-payments/${employeeId}/items`);
export const updateSalaryPayment = (id, data) => api.patch(`/api/v1/finance/salary-payments/${id}`, data);
export const closePeriodPayments = (periodId) => api.post(`/api/v1/finance/periods/${periodId}/payments/close`);
export const reopenPeriodPayments = (periodId, admin_pin) =>
  api.post(`/api/v1/finance/periods/${periodId}/payments/reopen`, null, { params: { admin_pin } });
export const postPeriodToLedger = (periodId) =>
  api.post(`/api/v1/finance/periods/${periodId}/post-to-ledger`);
export const calculatePayroll = (period_id, { force = false, mode, admin_pin } = {}) =>
  api.post(`/api/v1/payroll/periods/${period_id}/calculate`, null, {
    params: { force, ...(mode ? { mode } : {}), ...(admin_pin ? { admin_pin } : {}) },
  });
export const getPayrollPipeline = (period_id) =>
  api.get(`/api/v1/payroll/periods/${period_id}/pipeline`);
export const setPayrollPipeline = (period_id, stage) =>
  api.patch(`/api/v1/payroll/periods/${period_id}/pipeline`, { stage });
export const getEmployeeReviews = (period_id) =>
  api.get(`/api/v1/payroll/periods/${period_id}/employee-reviews`);
export const patchEmployeeReview = (period_id, employee_id, data) =>
  api.patch(`/api/v1/payroll/periods/${period_id}/employee-reviews/${employee_id}`, data);
export const getEmployeeDossier = (period_id, employee_id) =>
  api.get(`/api/v1/payroll/periods/${period_id}/dossier/${employee_id}`);
// ردیف‌های اصلاحیِ حقوق (فقط برای محاسبهٔ همین ماه) — لیست و جایگزینیِ کامل
export const getPayrollAdjustments = (period_id, employee_id) =>
  api.get(`/api/v1/payroll/periods/${period_id}/adjustments/${employee_id}`);
export const recalcEmployeePayroll = (period_id, employee_id, { overwrite = false, admin_pin } = {}) =>
  api.post(`/api/v1/payroll/periods/${period_id}/recalculate/${employee_id}`, null,
    { params: { overwrite_manual: overwrite, ...(admin_pin ? { admin_pin } : {}) } });
// انتقالِ بدهی به ماهِ بعد (v2.109.0)
export const getDebtDeferrals = (period_id, employee_id) =>
  api.get(`/api/v1/payroll/periods/${period_id}/deferrals/${employee_id}`);
export const createDebtDeferral = (period_id, employee_id, data, admin_pin) =>
  api.post(`/api/v1/payroll/periods/${period_id}/deferrals/${employee_id}`, data,
    { params: admin_pin ? { admin_pin } : {} });
export const deleteDebtDeferral = (period_id, employee_id, txn_id, admin_pin) =>
  api.delete(`/api/v1/payroll/periods/${period_id}/deferrals/${employee_id}/${txn_id}`,
    { params: admin_pin ? { admin_pin } : {} });
// کارت‌های دستگاه و ترددهای خام (v2.110.1)
export const getDeviceCards = (year, month) => api.get("/api/v1/attendance/device-cards", { params: { year, month } });
export const getDeviceCardPunches = (uid, year, month) =>
  api.get(`/api/v1/attendance/device-cards/${uid}/punches`, { params: { year, month } });
export const moveDeviceCard = (uid, data, dryRun = false) =>
  api.post(`/api/v1/attendance/device-cards/${uid}/move`, data, { params: dryRun ? { dry_run: true } : {} });
export const addRawPunch = (data) => api.post("/api/v1/attendance/raw-punches", data);
export const deleteRawPunch = (id) => api.delete(`/api/v1/attendance/raw-punches/${id}`);
export const putPayrollAdjustments = (period_id, employee_id, items, admin_pin) =>
  api.put(`/api/v1/payroll/periods/${period_id}/adjustments/${employee_id}`, { items },
    { params: admin_pin ? { admin_pin } : {} });
export const getPayComponents = (employee_id, params) =>
  api.get(`/api/v1/payroll/employees/${employee_id}/pay-components`, { params });
export const addPayComponent = (employee_id, data) =>
  api.post(`/api/v1/payroll/employees/${employee_id}/pay-components`, data);
export const deactivatePayComponent = (employee_id, comp_id) =>
  api.delete(`/api/v1/payroll/employees/${employee_id}/pay-components/${comp_id}`);
export const updatePayComponent = (employee_id, comp_id, data) =>
  api.patch(`/api/v1/payroll/employees/${employee_id}/pay-components/${comp_id}`, data);
// ادغامِ پروندهٔ تکراری — یک نفر نباید دو پرونده داشته باشد
export const getDuplicateEmployees = () => api.get("/api/v1/employees/duplicates");
export const previewEmployeeMerge = (data) => api.post("/api/v1/employees/merge-preview", data);
export const mergeEmployees = (data) => api.post("/api/v1/employees/merge", data);
// v2.162.0 — «این دو نفر جدا هستند» (دیگر تکراری پیشنهاد نشوند) / برگرداندن
export const markEmployeesDistinct = (a_id, b_id) => api.post("/api/v1/employees/duplicates/distinct", { a_id, b_id });
export const unmarkEmployeesDistinct = (id) => api.delete(`/api/v1/employees/duplicates/distinct/${id}`);
export const approvePayroll = (period_id, approved_by) =>
  api.post(`/api/v1/payroll/periods/${period_id}/approve`, null, { params: { approved_by } });
export const getPayrollRecords = (period_id) =>
  api.get(`/api/v1/payroll/periods/${period_id}/records`);
export const getAdvances = (period_id) =>
  api.get("/api/v1/payroll/advances", { params: { period_id } });
export const createAdvance = (data) =>
  api.post("/api/v1/payroll/advances", data, { params: { created_by: 1 } });
export const createBulkAdvances = (data) =>
  api.post("/api/v1/payroll/advances/bulk", data, { params: { created_by: 1 } });
export const updateAdvance = (id, data) => api.patch(`/api/v1/payroll/advances/${id}`, data);
export const deleteAdvance = (id) => api.delete(`/api/v1/payroll/advances/${id}`);

export const getDeductions = (period_id) =>
  api.get("/api/v1/payroll/deductions", { params: { period_id } });
export const createDeduction = (data) =>
  api.post("/api/v1/payroll/deductions", data, { params: { created_by: 1 } });
export const updateDeduction = (id, data) => api.patch(`/api/v1/payroll/deductions/${id}`, data);
export const deleteDeduction = (id) => api.delete(`/api/v1/payroll/deductions/${id}`);

export const resetPayroll = (period_id) =>
  api.post(`/api/v1/payroll/periods/${period_id}/reset`);
export const deletePeriod = (period_id, admin_pin) =>
  api.delete(`/api/v1/payroll/periods/${period_id}`, { params: admin_pin ? { admin_pin } : {} });

// ---- Audit ----
export const getAuditLog = (params) => api.get("/api/v1/audit/", { params });

// ---- Piece Rate ----
export const createPieceRate = (data) => api.post("/api/v1/piece-rate/", data);
export const validatePieceRate = (product_type) =>
  api.get("/api/v1/piece-rate/validate", { params: { product_type } });
const _pieceRateForm = (file, params, path) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/api/v1/piece-rate/${path}`, fd, {
    params, headers: { "Content-Type": "multipart/form-data" },
  });
};
/** پیش‌نمایشِ ایمپورت نرخنامه — هیچ چیزی ذخیره نمی‌شود */
export const previewPieceRateImport = (file, params) => _pieceRateForm(file, params, "import/preview");
/** اعمالِ ایمپورت (به‌روزرسانیِ درجا، تراکنشی) */
export const importPieceRate = (file, params) => _pieceRateForm(file, params, "import");
/** پیش‌نمایشِ اصلاحِ نرخ‌های تومانیِ قبلی (×۱۰) */
export const pieceRateUnitFixPreview = () => api.get("/api/v1/piece-rate/unit-fix/preview");
/** اعمالِ تراکنشیِ اصلاحِ تومان→ریال */
export const pieceRateUnitFix = () => api.post("/api/v1/piece-rate/unit-fix", null, { params: { confirm: true } });

// ---- Production Orders (edit/QC) ----
export const updateOrder = (id, data, admin_pin) =>
  api.patch(`/api/v1/orders/${id}`, data, { params: admin_pin ? { admin_pin } : {} });
export const deleteOrder = (id, admin_pin) =>
  api.delete(`/api/v1/orders/${id}`, { params: admin_pin ? { admin_pin } : {} });
export const updateEntry = (orderId, entryId, data, admin_pin) =>
  api.patch(`/api/v1/orders/${orderId}/entries/${entryId}`, data, { params: admin_pin ? { admin_pin } : {} });
export const deleteEntry = (orderId, entryId, admin_pin) =>
  api.delete(`/api/v1/orders/${orderId}/entries/${entryId}`, { params: admin_pin ? { admin_pin } : {} });
export const getQcPrediction = (orderId) =>
  api.get(`/api/v1/orders/${orderId}/qc-prediction`);
export const reopenOrder = (orderId, { full = false, admin_pin } = {}) =>
  api.patch(`/api/v1/orders/${orderId}/reopen`, null,
    { params: { full, ...(admin_pin ? { admin_pin } : {}) } });
export const getQcOperationCandidates = (orderId, stage = "qc1") =>
  api.get(`/api/v1/orders/${orderId}/qc-operation-candidates`, { params: { stage } });
export const saveQcOperationResults = (orderId, payload) =>
  api.post(`/api/v1/orders/${orderId}/qc-operation-results`, payload);
export const getOrdersList = () => api.get("/api/v1/orders/");
export const getOrder = (id) => api.get(`/api/v1/orders/${id}`);
export const createOrder = (data) => api.post("/api/v1/orders/", data);
/** ویرایش گروهیِ پارت‌ها — تراکنشی (all-or-nothing) */
export const ordersBulkUpdate = (items, admin_pin) =>
  api.post("/api/v1/orders/bulk-update", { items }, { params: admin_pin ? { admin_pin } : {} });
// برگهٔ کارکرد یک‌جا و تراکنشی (v2.112.4)
export const addOrderEntriesBulk = (order_id, entries) =>
  api.post(`/api/v1/orders/${order_id}/entries/bulk`, { entries });
export const addOrderEntry = (orderId, data) => api.post(`/api/v1/orders/${orderId}/entries`, data);
/** ثبت‌ها به شکلِ همان گریدِ ورود — برای «ویرایش عیناً همان برگه» */
export const getOrderEntryGrid = (orderId, size_label) =>
  api.get(`/api/v1/orders/${orderId}/entry-grid`, { params: { size_label } });
export const deleteCutterJob = (orderId, jobId) => api.delete(`/api/v1/orders/${orderId}/cutter-jobs/${jobId}`);
export const updateOrderEntry = (orderId, entryId, data, admin_pin) =>
  api.patch(`/api/v1/orders/${orderId}/entries/${entryId}`, data, { params: admin_pin ? { admin_pin } : {} });

// ---- تولید و بسته‌بندی: ثبت برش → ضایعات → مدیریت تولید ----
const _code = (c) => encodeURIComponent(c);
/** ثبت/ویرایش یک بیجک برش (شماره بیجک + کد بیجک + ردیف‌های محصول/رنگ/سایز) */
export const saveCutBijack = (data) => api.post("/api/v1/orders/cut-bijack", data);
export const updateCutBijack = (code, data) => api.put(`/api/v1/orders/cut-bijack/${_code(code)}`, data);
// حذفِ بیجک یا یک محصولِ آن — اول impact را بگیر تا کاربر بداند چه پاک می‌شود
export const cutBijackDeleteImpact = (code, orderId) =>
  api.get(`/api/v1/orders/cut-bijack/${_code(code)}/delete-impact`,
    { params: orderId ? { order_id: orderId } : {} });
export const deleteCutBijack = (code, { orderId, adminPin } = {}) =>
  api.delete(`/api/v1/orders/cut-bijack/${_code(code)}`,
    { params: { ...(orderId ? { order_id: orderId } : {}), ...(adminPin ? { admin_pin: adminPin } : {}) } });
export const getCutBijacks = (params) => api.get("/api/v1/orders/cut-bijacks", { params });
export const renameBijackCode = (code, new_production_code) =>
  api.patch(`/api/v1/orders/cut-bijack/${encodeURIComponent(code)}/code`,
    { new_production_code });
export const bulkUpdateBijacks = (items) =>
  api.post("/api/v1/orders/cut-bijacks/bulk-update", { items });
export const checkCutBijackNo = (bijack_no) =>
  api.get(`/api/v1/orders/cut-bijack/by-number/${encodeURIComponent(bijack_no)}`);
/** ردیف‌های «نرخ برش» نرخ‌نامه (فی هر جین) */
export const getCutRates = () => api.get("/api/v1/orders/cut-rates");
/** کارکرد و حقوق برشکار یک کد تولید — نرخ Snapshot می‌شود */
export const addBijackCutterJob = (code, data) =>
  api.post(`/api/v1/orders/cut-bijack/${_code(code)}/cutter-job`, data);
export const getWasteEvents = (params) => api.get("/api/v1/orders/waste-events", { params });
export const createWasteEvent = (data) => api.post("/api/v1/orders/waste-events", data);
export const deleteWasteEvent = (id) => api.delete(`/api/v1/orders/waste-events/${id}`);
/** ردیف‌های محصول + جمع‌های پایین لیست (بر اساس فیلتر جاری) */
export const getProductionRows = (params) => api.get("/api/v1/orders/production-rows", { params });
/** پرتکرارها — کدام پرسنل معمولاً کدام عملیات را می‌زند (فقط برای مرتب‌سازیِ فهرست) */
export const getProductionFrequentPicks = (params) =>
  api.get("/api/v1/production/frequent-picks", { params });
/** بستنِ تولیدِ ماه — «آخرین سریِ این ماه ثبت شد» */
export const getProductionMonth = (year, month) =>
  api.get("/api/v1/orders/production-month", { params: { year, month } });
export const closeProductionMonth = (data) =>
  api.post("/api/v1/orders/production-month/close", data);
export const reopenProductionMonth = (year, month) =>
  api.post("/api/v1/orders/production-month/reopen", null, { params: { year, month } });
export const productionRowsBulkUpdate = (items) =>
  api.post("/api/v1/orders/production-rows/bulk-update", { items });
// `orderId` ⇒ فقط همان محصول (هر محصول صفحهٔ تولیدِ جدای خودش را دارد)
export const getBijackOverview = (code, orderId) =>
  api.get(`/api/v1/orders/bijack/${_code(code)}/overview`,
    { params: orderId ? { order_id: orderId } : {} });
/** کنترل اول (qc1) / کنترل نهایی (qc2) per ردیف محصول */
export const addOrderQC = (orderId, data) => api.post(`/api/v1/orders/${orderId}/qc`, data);
export const updateOrderQC = (orderId, qcId, data) => api.patch(`/api/v1/orders/${orderId}/qc/${qcId}`, data);
export const deleteOrderQC = (orderId, qcId) => api.delete(`/api/v1/orders/${orderId}/qc/${qcId}`);
/** پاک‌کردنِ کلِ دوختِ یک سایز (یا کلِ محصول با size_label خالی) — پیش‌نمایش و اجرا */
export const getSewingResetImpact = (orderId, sizeLabel) =>
  api.get(`/api/v1/orders/${orderId}/sewing-reset-impact`, { params: sizeLabel ? { size_label: sizeLabel } : {} });
// v2.143.0 — «دوخت تکمیل» / «تکمیل»ِ دستی per سایز (stage=null ⇒ برداشتن)
export const setManualStage = (orderId, sizeLabel, stage) =>
  api.post(`/api/v1/orders/${orderId}/manual-stage`, { size_label: sizeLabel || null, stage });
export const resetSewing = (orderId, sizeLabel) =>
  api.post(`/api/v1/orders/${orderId}/sewing-reset`, { size_label: sizeLabel || null });
/** افزودنِ سایز به پارت — برای برگرداندنِ سایزِ «بدونِ برش» به بیجک */
export const addOrderSize = (orderId, data) => api.post(`/api/v1/orders/${orderId}/sizes`, data);
export const getPieceRates = (params) => api.get("/api/v1/piece-rate/", { params });

// ---- کاتالوگ محصول / رنگ / سایز ----
export const getProductionOptions = (params) =>
  api.get("/api/v1/settings/production-options", { params });
export const createProductionOption = (data) =>
  api.post("/api/v1/settings/production-options", data);
export const updateProductionOption = (id, data) =>
  api.patch(`/api/v1/settings/production-options/${id}`, data);
export const deactivateProductionOption = (id) =>
  api.delete(`/api/v1/settings/production-options/${id}`);

// ---- Auth ----
export const login = (username, password) =>
  api.post("/api/v1/auth/login", { username, password });
export const getMe = () => api.get("/api/v1/auth/me");

// ---- Supply Chain (زنجیره تأمین) ----
export const scEventHistory = (event_id) =>
  api.get(`/api/v1/supply-chain/events/${event_id}/history`);
// چیدمانِ جدول‌ها per کاربر روی سرور (v2.170.0) — layoutStore صدا می‌زند
export const getUiPrefs = () => api.get("/api/v1/auth/ui-prefs");
export const saveUiPrefs = (items) => api.put("/api/v1/auth/ui-prefs", items);
export const scGetParties =(params) => api.get("/api/v1/supply-chain/parties", { params });
export const scCreateParty = (data) => api.post("/api/v1/supply-chain/parties", data);
export const scUpdateParty = (id, data) => api.patch(`/api/v1/supply-chain/parties/${id}`, data);
export const scGetItems = () => api.get("/api/v1/supply-chain/items");
export const scCreateItem = (data) => api.post("/api/v1/supply-chain/items", data);
export const scGetEvents = (params) => api.get("/api/v1/supply-chain/events", { params: { ...params, _ts: Date.now() } });
export const scGetEvent = (id) => api.get(`/api/v1/supply-chain/events/${id}`);
export const scCreateEvent = (data) => api.post("/api/v1/supply-chain/events", data);
export const scUpdateEvent = (id, data) => api.patch(`/api/v1/supply-chain/events/${id}`, data);
export const scApproveEvent = (id) => api.post(`/api/v1/supply-chain/events/${id}/approve`);
export const scCancelEvent = (id, reason) => api.post(`/api/v1/supply-chain/events/${id}/cancel`, { reason });
// فاکتورهای لغوشده — جدا از فهرستِ فاکتورها نگه داشته می‌شوند
export const scGetCancelledEvents = () =>
  api.get("/api/v1/supply-chain/events-cancelled", { params: { _ts: Date.now() } });
export const scRestoreEvent = (id) => api.post(`/api/v1/supply-chain/events/${id}/restore`);
export const scBulkDeleteEvents = (ids) =>
  api.post("/api/v1/supply-chain/events/bulk-delete", { ids });
export const scBulkRestoreEvents = (ids) =>
  api.post("/api/v1/supply-chain/events/bulk-restore", { ids });
export const scDeleteEvent = (id) => api.delete(`/api/v1/supply-chain/events/${id}`);
export const scWarehouseReceipt = (data) => api.post("/api/v1/supply-chain/warehouse-receipts", data);
export const scYarnPurchasesAvailable = () => api.get("/api/v1/supply-chain/yarn-purchases-available");
export const scCustodyLedger = (params) => api.get("/api/v1/supply-chain/custody-ledger", { params });
// مانده اول دوره — شروعِ حسابِ هر طرف در ابتدای سال
export const scOpeningBalances = (year) =>
  api.get("/api/v1/supply-chain/opening-balances", { params: year ? { year } : {} });
export const scSetOpeningBalance = (data, year) =>
  api.put("/api/v1/supply-chain/opening-balances", data, { params: year ? { year } : {} });
export const scDeleteOpeningBalance = (partyId, year) =>
  api.delete(`/api/v1/supply-chain/opening-balances/${partyId}`, { params: year ? { year } : {} });
export const scWarehouseInventory = (partyId) => api.get(`/api/v1/supply-chain/warehouse/${partyId}/inventory`);
export const scPartyLedgerLog = (partyId) => api.get(`/api/v1/supply-chain/party/${partyId}/ledger-log`);
export const scDashboardStages = (status) => api.get("/api/v1/supply-chain/dashboard/stages", { params: status ? { status } : {} });
export const scDashboard = (params) => api.get("/api/v1/supply-chain/dashboard", { params });
export const scDashboardAnalytics = (params) => api.get("/api/v1/supply-chain/dashboard/analytics", { params });
export const scStageTrend = (months = 6) => api.get("/api/v1/supply-chain/dashboard/trend", { params: { months } });
export const scGetWasteRules = () => api.get("/api/v1/supply-chain/waste-rules");
export const scSetWasteRules = (rules) => api.put("/api/v1/supply-chain/waste-rules", { rules });
export const scGetBatches = () => api.get("/api/v1/supply-chain/batches");
export const scCreateBatch = (data) => api.post("/api/v1/supply-chain/batches", data);
export const scBatchTimeline = (id) => api.get(`/api/v1/supply-chain/batches/${id}/timeline`);
export const scReviewQueue = () => api.get("/api/v1/supply-chain/review-queue");
export const scImportUpload = (file, template = "derin_statement", partyId = null) => {
  const fd = new FormData(); fd.append("file", file); fd.append("template", template);
  if (partyId) fd.append("party_id", String(partyId));   // شرکتِ صاحبِ فایل (اختیاری)
  return api.post("/api/v1/supply-chain/import/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
};
// اختلافِ باسکولی (مستقل) — آپلودِ کاردکسِ پوشان + فهرست + پاک‌سازی
export const scScaleUpload = (file) => {
  const fd = new FormData(); fd.append("file", file);
  return api.post("/api/v1/supply-chain/scale-discrepancy/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
};
export const scScaleList = () => api.get("/api/v1/supply-chain/scale-discrepancy");
export const scScaleAdd = (data) => api.post("/api/v1/supply-chain/scale-discrepancy", data);
export const scScaleEdit = (id, data) => api.patch(`/api/v1/supply-chain/scale-discrepancy/${id}`, data);
export const scScaleDeleteOne = (id) => api.delete(`/api/v1/supply-chain/scale-discrepancy/${id}`);
export const scScaleFromSystem = () => api.post("/api/v1/supply-chain/scale-discrepancy/import-from-system");
export const scScaleClear = () => api.delete("/api/v1/supply-chain/scale-discrepancy");
export const scImportSessions = () => api.get("/api/v1/supply-chain/import/sessions");
export const scImportSession = (id) => api.get(`/api/v1/supply-chain/import/sessions/${id}`);
export const scImportRowPatch = (id, data) => api.patch(`/api/v1/supply-chain/import/rows/${id}`, data);
export const scImportApprove = (id, rowIds) => api.post(`/api/v1/supply-chain/import/sessions/${id}/approve-selected`, { row_ids: rowIds });
// دانلودِ قالبِ نمونه (Excel) — به‌صورتِ blob تا با baseURLِ درست و بدونِ مشکلِ مسیر کار کند
export const downloadTemplate = async (name, filename) => {
  const r = await api.get(`/api/v1/templates/${name}`, { responseType: "blob" });
  return saveResponse(r, filename || `${name}.xlsx`);
};
export const scReportMonthly = (year, month) => api.get("/api/v1/supply-chain/reports/monthly", { params: { year, month } });
export const scReportPartyBalance = () => api.get("/api/v1/supply-chain/reports/party-balance");
export const scReportWeightVariance = () => api.get("/api/v1/supply-chain/reports/weight-variance");
export const scReportCostPerKg = (params) => api.get("/api/v1/supply-chain/reports/cost-per-kg", { params });
// بروزرسانیِ تک‌فایلی (فقط super_admin)
export const updateVersion = () => api.get("/api/v1/update/version");
export const updateHistory = (limit = 20) => api.get("/api/v1/update/history", { params: { limit } });
export const updateHealth = () => api.get("/api/v1/update/health");
export const updateVerify = (fd) => api.post("/api/v1/update/verify", fd, _mp);
// جریانِ دومرحله‌ای: اول بسته را staging کن و بررسی شود، بعد نصب
export const updateStage = (file) => {
  const form = new FormData(); form.append("file", file);
  return api.post("/api/v1/update/stage", form, { ..._mp, timeout: 300000 });
};
export const updateStageLink = (url, expected_sha256) =>
  api.post("/api/v1/update/stage-link", _fd({ url, expected_sha256 }), { ..._mp, timeout: 600000 });
export const updateStageStatus = (sid) => api.get(`/api/v1/update/stage/${sid}/status`);
export const updateStageDiscard = (sid) => api.delete(`/api/v1/update/stage/${sid}`);
export const updateApplyStaged = (data) =>
  api.post("/api/v1/update/apply", _fd(data), { ..._mp, timeout: 600000 });
/** نصب با پنجرهٔ «اجازه»: بلافاصله برمی‌گردد، نصب سرِ مهلت انجام می‌شود */
export const updateApplyScheduled = (data) =>
  api.post("/api/v1/update/apply-scheduled", _fd(data), { ..._mp, timeout: 120000 });
export const updateRollback = (data) => api.post("/api/v1/update/rollback", _fd(data), _mp);
// منسوخ — نگه داشته شده تا کدِ قدیمی نشکند
export const updateApply = (fd) => api.post("/api/v1/update/apply-direct", fd, _mp);
export const updateApplyLink = (fd) => api.post("/api/v1/update/apply-link", fd, _mp);
// حمل و بارنامه
export const scFreightList = (params) => api.get("/api/v1/supply-chain/freight", { params });
export const scFreightCreate = (data) => api.post("/api/v1/supply-chain/freight", data);
export const scFreightUpdate = (id, data) => api.patch(`/api/v1/supply-chain/freight/${id}`, data);
export const scFreightDelete = (id) => api.delete(`/api/v1/supply-chain/freight/${id}`);
// ویرایشِ گروهی (تراکنشی — all-or-nothing)؛ items = [{id, ...changes}]
export const scBulkUpdateEvents = (items) => api.post("/api/v1/supply-chain/events/bulk-update", { items });
/** خروجی Excel سازگار با ایمپورت همگانی */
export const scExportEventsForImport = async (ids) => {
  const r = await api.post("/api/v1/supply-chain/events/export-for-import", { ids }, { responseType: "blob" });
  return saveResponse(r, `gharchak-events-import-${new Date().toISOString().slice(0, 10)}.xlsx`);
};
export const scFreightBulkUpdate = (items) => api.post("/api/v1/supply-chain/freight/bulk-update", { items });
export const scScaleBulkUpdate = (items) => api.post("/api/v1/supply-chain/scale-discrepancy/bulk-update", { items });
// فاکتورهای حسابداری (SCDocument)
export const scDocuments = (params) => api.get("/api/v1/supply-chain/documents", { params: { ...params, _ts: Date.now() } });
export const scDocumentCreate = (data) => api.post("/api/v1/supply-chain/documents", data);
export const scDocumentUpdate = (id, data) => api.patch(`/api/v1/supply-chain/documents/${id}`, data);
export const scDocumentsBulkUpdate = (items) => api.post("/api/v1/supply-chain/documents/bulk-update", { items });
export const scDocumentDelete = (id) => api.delete(`/api/v1/supply-chain/documents/${id}`);

export const API_BASE = process.env.REACT_APP_API_URL || apiOrigin();
export default api;

/** نسخهٔ اپ از بک‌اند — تنها منبعِ حقیقت، تا فرانت عقب نیفتد */
export const getAppVersion = () => api.get("/api/v1/meta/version");

// ---- ماهِ محاسبهٔ حقوق (جدا از تاریخِ کار) ----
/** کارکردی که در حقوقِ این ماه شمرده می‌شود */
export const getWorkMonth = (params) => api.get("/api/v1/payroll/work-month", { params });
/** انتقالِ کارکرد به ماهِ حقوقیِ دیگر */
export const moveWorkMonth = (data) => api.post("/api/v1/payroll/work-month/move", data);
/** برگرداندن به ماهِ تاریخِ کار */
export const resetWorkMonth = (data) => api.post("/api/v1/payroll/work-month/reset", data);

/** ماهِ محاسبهٔ حقوقِ یک پارت — به کارِ برش/تولید/کنترلِ همان پارت سرایت می‌کند */
export const setOrderPayrollMonth = (orderId, data) =>
  api.patch(`/api/v1/orders/${orderId}/payroll-month`, data);

// ---- اعلانِ بروزرسانیِ سیستم ----
export const getMaintenanceStatus = () => api.get("/api/v1/maintenance/status");
/** «همین حالا انجام بده» / «بعداً» — هر کاربرِ واردشده می‌تواند بزند */
export const approveMaintenance = () => api.post("/api/v1/maintenance/approve");
export const deferMaintenance = () => api.post("/api/v1/maintenance/defer");
export const requestMaintenance = (data) => api.post("/api/v1/maintenance/request", data);
export const announceMaintenance = (data) =>
  api.post("/api/v1/maintenance/announce", data);
export const startMaintenance = () => api.post("/api/v1/maintenance/start");
export const finishMaintenance = () => api.post("/api/v1/maintenance/finish");
export const clearMaintenance = () => api.delete("/api/v1/maintenance/");
